"use client";

import { createContext, useContext } from "react";
import {
    GetNotificationsType,
    MarkNotificationAsRead,
    MarkNotificationsAsReadType,
} from "~/app/preferences/types";

interface NotificationsContextType {
    getNotifications: GetNotificationsType;
    markAllNotificationsAsRead: MarkNotificationsAsReadType;
    markNotificationAsRead: MarkNotificationAsRead;
}

interface NotificationProviderProps extends NotificationsContextType {
    children: React.ReactNode;
}

const NotificationsContext = createContext<
    NotificationsContextType | undefined
>(undefined);

export const NotificationsProvider = ({
    children,
    getNotifications,
    markAllNotificationsAsRead,
    markNotificationAsRead,
}: NotificationProviderProps) => {
    return (
        <NotificationsContext.Provider
            value={{
                getNotifications,
                markAllNotificationsAsRead,
                markNotificationAsRead,
            }}
        >
            {children}
        </NotificationsContext.Provider>
    );
};

export const useNotifications = () => {
    const context = useContext(NotificationsContext);

    if (!context) {
        throw new Error(
            "useNotifications must be used within a NotificationsProvider",
        );
    }

    return context;
};
